import NextLink from 'next/link';

import { pathnames } from '@/navigation';
import { Link as TranslatedLink } from '@/navigation';

type Props = Omit<React.ComponentProps<typeof TranslatedLink>, 'href'> & {
  href: keyof typeof pathnames | string;
  children: React.ReactNode;
};

const Link = ({ href, children, ...rest }: Props) => {
  // Check if href is in pathNames and decide which Link to use
  const isInternal = Object.keys(pathnames).includes(href as string);
  const Link = isInternal ? TranslatedLink : NextLink;

  return (
    <Link
      href={href as keyof typeof pathnames} // TODO: Fix this typing
      {...(isInternal ? {} : { target: '_blank' })}
      {...(isInternal ? {} : { referrerPolicy: 'no-referrer' })}
      {...rest}
    >
      {children}
    </Link>
  );
};

export default Link;
